/* eslint-disable no-restricted-imports */
import { forwardRef, PropsWithChildren, Ref } from 'react';
import { Box, BoxProps } from '@mui/material';
import { useCentralContainerRemainingSpace } from 'integration/hooks/useCentralContainerRemainingSpace';
import { useScrollbarWidth } from 'integration/hooks/useScrollbarWidth';

export const DpScrollHeader = forwardRef(
	({ children, sx, ...props }: PropsWithChildren<BoxProps>, ref: Ref<HTMLDivElement>) => {
		const spacing = useCentralContainerRemainingSpace();
		const scrollBarWidth = useScrollbarWidth();

		return (
			<Box
				ref={ref}
				sx={{
					display: 'flex',
					flexDirection: 'column',
					maxWidth: `calc(100vw - (${scrollBarWidth}px + 0px))`,
					paddingLeft: `calc(${spacing})`,
					paddingRight: `calc(${spacing} - (${scrollBarWidth}px + 20px))`,
					marginBottom: '22px',
				}}
				{...props}
			>
				{children}
			</Box>
		);
	}
);
